import { MARQUEE_ITEMS } from "./data";

export function Marquee() {
  const row = (ariaHidden) => (
    <div className="marquee-row" aria-hidden={ariaHidden || undefined}>
      {MARQUEE_ITEMS.map((item) => (
        <span className="marquee-item" key={`${ariaHidden}-${item}`}>
          {item}
          <i>//</i>
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee" data-testid="skills-marquee">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
